import React from 'react';
import i18n from '../../../i18n/i18n';
import axios from '../../../utils/AxiosWrapper';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import 'react-dates/initialize';

import 'react-dates/lib/css/_datepicker.css';
import { Button, Card, Link, Typography } from '@material-ui/core';
import DatePickerMeteo from '../../../utils/DatePickerMeteo';
import { formatData, formatForecast, formatDisease } from '../DataFormatters';
import { withStyles } from '@material-ui/core/styles';
import { MoonLoader } from 'react-spinners';
import MeteoTable from '../MeteoTable';
import MeteoInfoButton from '../MeteoInfoButton';
import InfoHumidityTemperature from '../Info/Forecast/InfoHumidityTemperature';
import InfoFrost from '../Info/Forecast/InfoFrost';

const styles = {
    value: { width: '8px', height: '8px', margin: '3px', borderRadius: '3px', padding: '8px', textAlign: 'center', fontWeight: 'bold', font: '12px', color: 'white' }
};

export class ForecastFrost extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            station_id: this.props.row.uid,
            startDate: moment().subtract(1, 'days'),
            endDate: moment(),
            forecast: {},
            week: false,
            load: true,
            frostRisk: [],
            barColors: []

        };
    }

    componentDidMount() {
        this.getPessl();
    }

    setDates = (start, end) => { this.setState({ startDate: start, endDate: end }, () => { this.getPessl(); }); }

    getForecast = async (path) => {
        await axios.post('/api/testMeteo/meteo', path)
            .then(res => { let obj = formatForecast(res); this.setState({ forecast: obj }); })
            .catch(err => console.log('Error: ', err))
        this.calculateFrostRisk()

    }

    calculateFrostRisk = () => {
        let T = this.state.forecast.temperature;
        let RH = this.state.forecast.relativehumidity;
        let W = this.state.forecast.windspeed;
        let WD = this.state.forecast.winddirection;
        let LW = this.state.forecast.leaf_wetness;

        // Define cold wind directions (example: N, NE, NW, E)
        const ColdWindDirections = ["N", "NE", "NW", "E"];

        // Defensive: check all arrays are same length
        const len = Math.min(
            (T && T.length) ? T.length : 0,
            (RH && RH.length) ? RH.length : 0,
            (W && W.length) ? W.length : 0,
            (WD && WD.length) ? WD.length : 0,
            (LW && LW.length) ? LW.length : 0
        );
        let frostRisk = [];
        for (let i = 0; i < len; i++) {
            let score = 0;
            // Temperature
            if (T[i] <= 0) score += 5;
            else if (T[i] <= 4) score += 3;

            // Relative Humidity
            if (RH[i] >= 85) score += 2;
            else if (RH[i] >= 70) score += 1;

            // Wind Speed
            if (W[i] < 1.5) score += 3;
            else if (W[i] < 3) score += 1;

            // Leaf Wetness
            if (LW[i] === "wet") score += 2;

            // Wind Direction
            if (ColdWindDirections.includes(WD[i])) score += 1;

            // Final risk value
            if (score >= 8) frostRisk.push(3);
            else if (score >= 4) frostRisk.push(2);
            else frostRisk.push(1);
        }
        // You can use frostRisk array for further processing or debugging
        console.log("Frost Risk:", frostRisk);
        // Optionally, set to state if needed:
        this.setState({ frostRisk }, () => this.generateValuesAndColors());
    }

    generateValuesAndColors() {
        let colors = [];
        for (let i = 0; i < this.state.frostRisk.length; i++) {
            const element = this.state.frostRisk[i];
            console.log(element)
            if (element === 3) {
                colors.push('#660000');
            } else if (element === 2) {
                colors.push('#C67465');
            } else {
                colors.push('#A1C16E');
            }
        }
        this.setState({ barColors: colors, load: false });
    }

    getPessl = () => {
        let start_date = moment(this.state.startDate).unix();
        let end_date = moment(this.state.endDate).unix();
        let station_id = this.state.station_id;

        // URL-ovi za podatke sa meteo stanica
        let disease_path = '/data/' + station_id + '/hourly/from/' + start_date + '/to/' + end_date;
        let forecast_path = '/forecast/' + station_id + '/hourly';
        let data_path = '/data/' + station_id + '/hourly/from/' + start_date + '/to/' + end_date;

        this.getForecast({ path: forecast_path, name: 'general7', method: "POST" });
    }

    render() {
        const { classes } = this.props;

        let graph1 = {};
        if (
            this.state.forecast.dates !== undefined
        ) {
            graph1 = {
                labels: this.state.week ? this.state.forecast.dates : this.state.forecast.dates.slice(0, 72),
                datasets: [
                    {
                        label: i18n.t('Temperature [°C]'),
                        hidden: true,
                        data: this.state.forecast.temperature,
                    },
                    {
                        label: i18n.t('Relative humidity [%]'),
                        hidden: true,
                        data: this.state.forecast.relativehumidity,
                    },
                    {
                        label: i18n.t('Wind Speed [m/s]'),
                        hidden: true,
                        data: this.state.forecast.windspeed,
                    },
                    {
                        label: i18n.t('Wind Direction [°]'),
                        hidden: true,
                        data: this.state.forecast.winddirection,
                    }, {
                        label: i18n.t('Leaf Wetness'),
                        hidden: true,
                        data: this.state.forecast.leaf_wetness,
                    },
                    {
                        data: this.state.week ? this.state.frostRisk : this.state.frostRisk.slice(0, 72),
                        label: i18n.t('Frost risk'),
                        backgroundColor: this.state.barColors,
                        type: 'bar',
                        borderWidth: 2,
                        yAxisID: 'y-axis-1',

                    },

                ],
            };
        }
        const options1 = {
            maintainAspectRatio: false,
            legend: {
                display: false,
            },
            tooltips: {
                displayColors: false,
                callbacks: {
                    label: (tooltipItem, chart) => graph1.datasets.map(ds => ds.label + ': ' + ds.data[tooltipItem.index]),
                },
            },
            scales: {
                xAxes: [
                    {
                        barPercentage: 1,
                        categoryPercentage: 1,
                        gridLines: {
                            drawOnChartArea: false
                        },
                    },
                ],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                        gridLines: {
                            drawOnChartArea: true
                        },
                        ticks: {
                            min: 0,
                            max: 3,
                            maxTicksLimit: 5
                        },
                    },
                ],
            },
        };

        return (
            <div style={{ paddingLeft: '35px', height: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <p style={{ fontSize: 20, marginRight: 4 }}>{i18n.t('Frost risk information')}</p>
                    </div>
                    <div style={{ marginLeft: 20 }}>
                        <MeteoInfoButton
                            title={i18n.t('Frost risk information')}
                            text={<InfoFrost />}
                            height='400px'
                            width='sm'
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', marginLeft: '44%', marginTop: '8px', textAlign: "center" }}>
                    <Link style={{ marginRight: '3px', marginLeft: '3px', fontSize: '18px', color: 'black', cursor: 'pointer' }}
                        onClick={() => { this.setState({ week: false }); }}
                        variant="contained"
                        color="secondary">
                        <Typography>{i18n.t('3 days')}</Typography>
                    </Link> /
                    <Link style={{ marginRight: '3px', marginLeft: '3px', fontSize: '18px', color: 'black', cursor: 'pointer' }}
                        onClick={() => { this.setState({ week: true }); }}
                        variant="contained"
                        color="secondary" >
                        <Typography>{i18n.t('7 days')}</Typography>
                    </Link>
                </div>
                <div style={{ marginTop: '22px', marginBottom: '17px', textAlign: "center" }}>
                    <span>{i18n.t('Low risk - ')}</span>
                    <span className={classes.value} style={{ background: '#A1C16E' }}>1</span>
                    <span className={classes.value} style={{ background: '#C67465' }}>2</span>
                    <span className={classes.value} style={{ background: '#660000' }}>3</span>
                    <span>{i18n.t(' - high risk')}</span>
                </div>

                {this.state.load === true && <div style={{ marginLeft: '39%', marginTop: '14%' }}> <MoonLoader loading={this.state.load} size={100} /></div>}
                {this.state.load === false &&


                    <div style={{ width: '95%', marginTop: '10px' }}>
                        <Bar data={graph1} height={300} width={600} options={options1} />
                        <MeteoTable data={{
                            headers: [i18n.t('Date and time'), i18n.t('Temperature [°C]'), i18n.t('Humidity [%]'), i18n.t('Wind Speed [m/s]'), i18n.t('Wind Direction [°]'), i18n.t('Leaf Wetness'), i18n.t('Frost risk')],
                            dates: this.state.week ? this.state.forecast.dates : this.state.forecast.dates.slice(0, 72),
                            temperature: this.state.week ? this.state.forecast.temperature : this.state.forecast.temperature.slice(0, 72),
                            relativehumidity: this.state.week ? this.state.forecast.relativehumidity : this.state.forecast.relativehumidity.slice(0, 72),
                            windspeed: this.state.week ? this.state.forecast.windspeed : this.state.forecast.windspeed.slice(0, 72),
                            winddirection: this.state.week ? this.state.forecast.winddirection : this.state.forecast.winddirection.slice(0, 72),
                            leaf_wetness: this.state.week ? this.state.forecast.leaf_wetness : this.state.forecast.leaf_wetness.slice(0, 72),
                            frostRisk: this.state.week ? this.state.frostRisk : this.state.frostRisk.slice(0, 72),
                        }} />
                        <div style={{ marginTop: '20px' }}></div>
                    </div>

                }
            </div>
        );
    }
};

export default withStyles(styles)(ForecastFrost);